import React from 'react';
import useGameStore from '../../store/gameStore';
import { AIDE_FRANCHISE_CHOIX } from '../../utils/franchise';
import { Megaphone } from 'lucide-react';
import { toast } from 'sonner';

/** Popup : un franchisé demande une aide (animation commerciale). */
const FranchiseAidePopup = () => {
  const ev = useGameStore(s => s.retail?.franchise?.aideEvent);
  const resoudre = useGameStore(s => s.resoudreAideFranchise);
  const treasury = useGameStore(s => s.treasury);
  if (!ev) return null;

  const choisir = (id) => {
    const res = resoudre(id);
    if (res && res.ok === false && res.error) toast.error(res.error);
  };

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="franchise-aide-popup">
      <div className="w-full max-w-lg rounded-xl border border-amber-500/40 bg-ink-800 shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="flex items-center gap-2 px-4 py-3 bg-amber-500/10 border-b border-amber-500/30">
          <Megaphone className="w-4 h-4 text-amber-400" />
          <p className="text-sm font-black text-foreground">Un franchisé demande votre aide</p>
          <span className="ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-400 text-ink-900">FRANCHISE</span>
        </div>
        <div className="p-4 space-y-3">
          <p className="text-xs text-slate-300 leading-relaxed">
            <strong>{ev.nom}</strong> ({ev.villeNom}) veut lancer une <strong>animation commerciale</strong> et
            sollicite l'enseigne. Résultat mensuel actuel : <strong>{(ev.resultatMensuel || 0).toLocaleString('fr-FR')} €</strong> —
            vos redevances suivront votre décision.
          </p>
          <div className="space-y-2">
            {AIDE_FRANCHISE_CHOIX.map((c) => (
              <button
                key={c.id}
                onClick={() => choisir(c.id)}
                disabled={c.cout > (treasury || 0)}
                className="w-full text-left rounded-lg border border-ink-600 bg-ink-700/50 hover:border-amber-500/50 hover:bg-ink-700 transition-colors p-3 disabled:opacity-40"
                data-testid={`aide-franchise-${c.id}`}
              >
                <div className="flex items-center justify-between gap-2">
                  <p className="text-xs font-bold text-foreground">{c.label}</p>
                  <span className={`text-[11px] font-mono font-bold ${c.effetPct > 0 ? 'text-money' : 'text-danger'}`}>
                    {c.cout > 0 ? `−${c.cout.toLocaleString('fr-FR')} €` : 'Gratuit'} · {c.effetPct > 0 ? '+' : ''}{c.effetPct} %
                  </span>
                </div>
                <p className="text-[11px] text-slate-400 mt-1">{c.detail}</p>
              </button>
            ))}
          </div>
          <p className="text-[10px] text-slate-500 italic">Sans réponse sous 5 jours, le franchisé s'essoufflera seul (−5 %).</p>
        </div>
      </div>
    </div>
  );
};

export default FranchiseAidePopup;
